import { getMySummaryCompetencyApi } from '../api';

export const getMySummaryCompetency = async ({
  employeeId,
  isCompetencyDescriptionRequired = false,
  limit = 3,
  offset = 0,
  isPreview,
}) => {
  try {
    const res = await getMySummaryCompetencyApi({
      employeeId,
      isCompetencyDescriptionRequired,
      limit,
      offset,
      isPreview,
    });
    return res?.entity;
  } catch (error) {
    console.error('Error fetching my summary for competency : ', error);
    return Promise.reject(error);
  }
};
